module.exports = __webpack_public_path__ + "media/images/icons/filled/flag-3fa25c23c916f4617ae3e58224fdfc89.svg";